import type { ReactNode } from "react";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import type { PublicFeatureFlag } from "@/services/api/features";

interface FeatureGateProps {
  /** Public feature flag that must be ON for the children to render. */
  flag: PublicFeatureFlag;
  children: ReactNode;
}

/**
 * Renders its children only when the given public feature flag is enabled.
 * While flags are still loading nothing is rendered (no flash of gated UI).
 */
export function FeatureGate({ flag, children }: FeatureGateProps) {
  const { isEnabled } = useFeatureFlags();

  if (!isEnabled(flag)) return null;

  return <>{children}</>;
}
